(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class ScrollingAnnouncementBanner extends HTMLElement {
    constructor() {
      super();
      this.track = null;
      this.content = null;
      this.resizeObserver = null;
    }

    connectedCallback() {
      this.track = this.querySelector('.header-scrolling-banner__track');
      this.content = this.querySelector('.header-scrolling-banner__content');
      
      if (!this.track || !this.content) return;
      
      // Wait for fonts to load before measuring
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.init());
      } else {
        // Fallback for browsers without font loading API
        setTimeout(() => this.init(), 100);
      }
    }

    init() {
      this.setupInfiniteScroll();
      this.setupAccessibility();
      
      // Re-calculate on resize
      this.resizeObserver = new ResizeObserver(() => {
        this.setupInfiniteScroll();
      });
      this.resizeObserver.observe(this);
    }

    setupInfiniteScroll() {
      // Remove animation temporarily for measurement
      this.track.classList.remove('animating');
      
      // Remove any existing clones
      const existingClones = this.track.querySelectorAll('.header-scrolling-banner__content:not(:first-child)');
      existingClones.forEach(clone => clone.remove());
      
      // Measure the original content width
      const contentWidth = this.content.offsetWidth;
      const containerWidth = this.offsetWidth;
      
      if (contentWidth === 0) return;
      
      // Calculate how many copies we need to ensure seamless loop
      // We need at least 2 copies (original + 1 clone) for the animation to work
      // But we may need more if content is shorter than container
      const copiesNeeded = Math.max(2, Math.ceil((containerWidth * 2) / contentWidth) + 1);
      
      // Clone the content the necessary number of times
      for (let i = 1; i < copiesNeeded; i++) {
        const clone = this.content.cloneNode(true);
        this.track.appendChild(clone);
      }
      
      // Calculate scroll duration based on speed setting and content width
      const speed = parseInt(this.dataset.speed) || 30;
      // Normalize speed: the setting is the time for one full loop
      // We want consistent perceived speed regardless of content width
      const duration = speed;
      
      this.track.style.setProperty('--scroll-duration', `${duration}s`);
      
      // Start animation
      requestAnimationFrame(() => {
        this.track.classList.add('animating');
      });
    }

    setupAccessibility() {
      const links = this.querySelectorAll('a');
      
      // Pause on hover
      this.addEventListener('mouseenter', () => {
        this.track.style.animationPlayState = 'paused';
      });
      
      this.addEventListener('mouseleave', () => {
        this.track.style.animationPlayState = 'running';
      });
      
      // Pause on focus
      links.forEach(link => {
        link.addEventListener('focus', () => {
          this.track.style.animationPlayState = 'paused';
        });
        
        link.addEventListener('blur', () => {
          this.track.style.animationPlayState = 'running';
        });
      });
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }
  }

  customElements.define('scrolling-announcement-banner', ScrollingAnnouncementBanner);

  } catch(e) { console.error(e); }
})();
})();
